
import { Spin, Icon } from 'antd';
import React from 'react';
const loadIcon = <Icon type="loading" />;

const Loader = () =>
    <div className='loader'>
        <Spin indicator={loadIcon} />
    </div>

export default Loader;